module.exports = __webpack_public_path__ + "media/images/clients/warning_bang-6e89d87c3462f1cdfcca2ffb48bd75e9.svg";